export default __webpack_public_path__ + "static/media/undraw_working_out_6psf.23e404ae.svg";